<template>
  <div class="">
    <form
      class="add-form"
      ref="customer_form"
      @submit.prevent="initNuveiSession"
      @keydown.enter.prevent="() => {}"
    >
      <!-- Organization -->
      <div class="form-wrapper">
        <base-input
          :label="`${$t('COMMON.ORGANIZATION')} (*)`"
          :placeholder="$t('COMMON.ORGANIZATION')"
          v-if="
            $currentUserCan($permissions.PERM_VIEW_ANY_ORGANIZATIONS) &&
            !hideOrganization
          "
        >
          <organization-selector
            :organization="nuveiCard.customer?.organization?.id"
            :filterable="true"
            :showAll="false"
            @organizationChanged="
              (organizationId) => {
                selectedOrganizationId = organizationId;
                selectedCustomer = {};
                onFormChanged();
              }
            "
            :disabled="!!nuveiCard.id || !sessionNotInitialized"
          />
        </base-input>
        <validation-error :errors="apiValidationErrors.organization" />
      </div>

      <div class="form-wrapper">
        <base-input
          :label="`${$t('COMMON.CUSTOMER')}`"
          :placeholder="$t('COMMON.CUSTOMER')"
          v-if="$currentUserCan($permissions.PERM_VIEW_ANY_CUSTOMERS)"
        >
          <customer-selector
            :customer="nuveiCard.customer?.id"
            :filterable="true"
            :showAll="false"
            :filterOrganization="selectedOrganizationId"
            @customerChanged="
              (customerId, customer) => {
                selectedCustomer = customer;
                cardHolderName = `${selectedCustomer.firstname} ${selectedCustomer.lastname}`;
                onFormChanged();
              }
            "
            :disabled="!sessionNotInitialized"
          />
        </base-input>
        <validation-error :errors="apiValidationErrors.customer" />
      </div>
      <div class="submit-wrapper">
        <base-button
          v-show="!showCardForm"
          type="button"
          class="btn btn-sm elite-submit"
          native-type="submit"
          :disabled="initializingNuvei"
        >
          <i class="fas fa-spinner fa-spin" v-if="initializingNuvei" />
          {{
            nuveiCard.id
              ? $t("NUVEI_CARDS.EDIT_NUVEI_CARD")
              : $t("NUVEI_CARDS.ADD_NUVEI_CARD")
          }}
        </base-button>
      </div>
      <div v-if="showCardForm" class="card-form form-group-wrapper">
        <!-- User + Shipping + Billing form -->
        <!-- <nuvei-user-form :model="selectedCustomer" ref="userForm" /> -->
        <!-- Formulaire nuvei -->
        <div class="form-group-wrapper-item">
          <base-input
            :label="$t('NUVEI_CARDS.CARD_HOLDER')"
            v-model="cardHolderName"
          />
        </div>

        <div class="form-group-wrapper-item">
          <base-input :label="$t('NUVEI_CARDS.CARD_NUMBER')">
            <div id="card-number" class="nuvei-field form-control pt-3"></div>
          </base-input>
        </div>

        <div class="form-group-wrapper-item">
          <base-input :label="$t('NUVEI_CARDS.CARD_EXPIRATION_DATE')">
            <div id="card-expiry" class="nuvei-field form-control pt-3"></div>
          </base-input>
        </div>

        <div class="form-group-wrapper-item">
          <base-input :label="$t('NUVEI_CARDS.CARD_CVC')">
            <div id="card-cvc" class="nuvei-field form-control pt-3"></div>
          </base-input>
        </div>

        <div class="form-wrapper full">
          <base-checkbox v-model="nuveiCard.is_default" class="mb-3">
            <span class="form-control-label">
              {{ $t("NUVEI_CARDS.SET_AS_DEFAULT") }}
            </span>
          </base-checkbox>
          <validation-error :errors="apiValidationErrors.is_default" />
        </div>

        <div class="submit-wrapper">
          <base-button
            type="button"
            class="mr-2 btn btn-sm elite-submit"
            @click="submitPayment"
            :disabled="loading || processing"
          >
            <i class="fas fa-spinner fa-spin" v-if="loading || processing" />
            {{ processing ? $t("Traitement...") : $t("Valider le paiement") }}
          </base-button>
          <base-button
            type="button"
            class="mr-2 btn btn-sm cancel elite-submit"
            :disabled="loading || processing"
            @click="
              showCardForm = false;
              sessionNotInitialized = true;
            "
          >
            {{ $t("COMMON.CANCEL") }}
          </base-button>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import { cloneDeep } from "lodash";
import { Option, Select, Table, TableColumn } from "element-ui";
import formMixin from "@/mixins/form-mixin";
import ValidationError from "@/components/ValidationError.vue";
import BaseInput from "@/components/Inputs/BaseInput.vue";
import OrganizationSelector from "@/components/OrganizationSelector.vue";
import CustomerSelector from "@/components/CustomerSelector.vue";
import "flatpickr/dist/flatpickr.css";
import { loadNuveiSDK } from "@/util/loadNuveiSDK.js";
import NuveiUserForm from "./NuveiUserForm.vue";

export default {
  layout: "DashboardLayout",
  name: "NuveiCardForm",

  components: {
    BaseInput,
    ValidationError,
    OrganizationSelector,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    CustomerSelector,
  },

  mixins: [formMixin],

  props: [
    "nuveiCardData",
    "formErrors",
    "loading",
    "hideOrganization",
    "hideNuveiCardable",
    "hideSubmit",
  ],

  data() {
    let nuveiCardData = { ...this.nuveiCardData };
    return {
      selectedOrganizationId: nuveiCardData.customer?.organization?.id || null,
      nuveiCard: nuveiCardData,
      processing: false,
      nuveiSessionData: {},
      safeChargeInstance: null,
      initialized: false,
      ScFields: null,
      cardNumber: null,
      cardExpiry: null,
      cardCvc: null,
      cardHolderName: "",
      paymentResponse: null,
      selectedCustomer: null,
      showCardForm: false,
      nuveiEnvironment: "int",
      nuveiCustomerId: null,
      initializingNuvei: false,
      sessionNotInitialized: true,
    };
  },

  created() {},

  mounted() {},

  computed: {},

  methods: {
    async initNuvei() {
      const SafeCharge = await loadNuveiSDK();
      this.safeChargeInstance = SafeCharge({
        merchantId: this.nuveiSessionData.merchantId,
        merchantSiteId: this.nuveiSessionData.merchantSiteId,
        env: this.nuveiEnvironment || "int",
      });
      const fieldStyles = {
        base: {
          fontFamily: "Roboto, sans-serif",
          color: "#4A5568",
          fontSize: "14px",
          "::placeholder": { color: "#95AAC1" },
        },
        invalid: { color: "#E30045" },
        valid: { color: "#35DE85" },
      };

      const fieldClasses = {
        focus: "focused",
        empty: "empty",
        invalid: "invalid",
      };

      this.ScFields = this.safeChargeInstance.fields({
        locale: "fr",
        fonts: [
          {
            cssUrl: "https://fonts.googleapis.com/css?family=Source+Code+Pro",
          },
        ],
      });

      this.cardNumber = this.ScFields.create("ccNumber", {
        style: fieldStyles,
        classes: fieldClasses,
      });
      this.cardNumber.attach("#card-number");

      this.cardExpiry = this.ScFields.create("ccExpiration", {
        style: fieldStyles,
        classes: fieldClasses,
      });
      this.cardExpiry.attach("#card-expiry");

      this.cardCvc = this.ScFields.create("ccCvc", {
        style: fieldStyles,
        classes: fieldClasses,
      });
      this.cardCvc.attach("#card-cvc");
      this.initialized = true;
    },

    async submitPayment() {
      this.processing = true;
      try {
        const sessionToken = this.nuveiSessionData.sessionToken;
        const cardHolderName = this.cardHolderName;
        if (!this.safeChargeInstance || !this.cardNumber) {
          this.$notify({
            type: "danger",
            message: this.$t("NUVEI_CARDS.NUVEI_NOT_INITIALIZED"),
          });
          return;
        }

        this.safeChargeInstance.createPayment(
          {
            sessionToken,
            cardHolderName: cardHolderName,
            paymentOption: this.cardNumber,
          },
          (response) => {
            console.log("Nuvei response:", response);
            this.processing = false;
            if (
              response.result === "SUCCESS" ||
              response.result === "APPROVED" ||
              response.result === "DECLINED"
            ) {
              this.paymentResponse = response;
              this.nuveiCard.nuvei_card_token = response.userPaymentOptionId;
              this.nuveiCard.brand = response.cardBrand ?? "";
              this.nuveiCard.last4 = response.last4Digits;
              this.nuveiCard.expiry_month = response.ccExpMonth;
              this.nuveiCard.expiry_year = response.ccExpYear;
              this.nuveiCard.metadata = {
                transaction: {
                  id: response.transactionId,
                  status: response.transactionStatus,
                  type: response.transactionType,
                },
              };
              this.sendInformation();
            }
            if (
              response.result === "ERROR" &&
              response.errorDescription === "incomplete_card_number"
            ) {
              this.$notify({
                type: "danger",
                message: this.$t("NUVEI_CARDS.INCOMPLETE_CARD_NUMBER"),
              });
            } else if (response.result === "ERROR") {
              this.$notify({
                type: "danger",
                message:
                  this.$t("ERRORS.SOMETHING_WENT_WRONG") +
                  ` (${response.errCode}: ${response.errorDescription})`,
              });
            }
          }
        );
      } catch (error) {
        console.error("Payment error:", error);
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.processing = false;
      }
    },

    async getNuveiSessionToken() {
      try {
        const response = await this.$store.dispatch(
          "nuveiCards/getNuveiSessionToken",
          this.selectedOrganizationId
        );
        this.nuveiSessionData = response.data;
        await this.initNuvei();
      } catch (error) {
        console.error("Error fetching Nuvei session token:", error);
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },

    async initNuveiSession() {
      try {
        // Doit sélectionner une organisation
        if (!this.selectedOrganizationId) {
          this.$notify({
            type: "danger",
            message: this.$t("NUVEI_CARDS.SELECT_ORGANIZATION_FIRST"),
          });
          return;
        }

        // Doit Sélectionner un client
        if (!this.selectedCustomer || !this.selectedCustomer.id) {
          this.$notify({
            type: "danger",
            message: this.$t("NUVEI_CARDS.SELECT_CUSTOMER_FIRST"),
          });
          return;
        }

        this.initializingNuvei = true;
        const params = {
          organizationId: this.selectedOrganizationId,
          customerId: this.selectedCustomer.id ?? null,
        };
        const response = await this.$store.dispatch(
          "nuveiCards/initNuveiSession",
          params
        );
        if (response.data.success !== true || !response.data?.data) {
          this.$notify({
            type: "danger",
            message:
              response.data.message || this.$t("ERRORS.SOMETHING_WENT_WRONG"),
          });
          this.initializingNuvei = false;
          return;
        }
        this.nuveiSessionData = response.data?.data || {};
        if (response.data?.data?.environment) {
          this.nuveiEnvironment = response.data?.data?.environment;
        }
        if (response.data?.nuvei_customer_id) {
          this.nuveiCustomerId = response.data.nuvei_customer_id;
          this.nuveiCard.nuvei_customer_id = this.nuveiCustomerId;
        }
        this.showCardForm = true;
        this.sessionNotInitialized = false;
        await this.initNuvei();
        this.initializingNuvei = false;
      } catch (error) {
        this.initializingNuvei = false;
        console.error("Error fetching Nuvei session token:", error);
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },

    async sendInformation() {
      let nuveiCardData = cloneDeep(this.nuveiCard);
      this.$emit("nuveiCardSubmitted", nuveiCardData);
    },
    onFormChanged() {
      this.$emit("formChanged");
    },
  },

  watch: {
    formErrors(errors) {
      if (errors) {
        this.setApiValidation(errors);
      }
    },
    nuveiCardData(nuveiCardData) {
      if (nuveiCardData) {
        this.nuveiCard = {
          ...this.nuveiCard,
          ...cloneDeep(nuveiCardData),
        };
      }
    },
  },
};
</script>
<style scoped>
.nuvei-field.form-control.focused {
  color: #8898aa;
  background-color: #fff;
  border-color: #5e72e4;
  outline: 0;
  -webkit-box-shadow: 0 3px 9px rgba(50, 50, 9, 0),
    3px 4px 8px rgba(94, 114, 228, 0.1);
  box-shadow: 0 3px 9px rgba(50, 50, 9, 0), 3px 4px 8px rgba(94, 114, 228, 0.1);
}
.add-form .cancel.elite-submit {
    background-color: #dc3545 !important;
    border-color: #dc3545 !important;
    color: #fff !important;
}
</style>
